const validStateCodes = [
	"AL",
	"AK",
	"AZ",
	"AR",
	"CA",
	"CO",
	"CT",
	"DE",
	"DC",
	"FL",
	"GA",
	"HI",
	"ID",
	"IL",
	"IN",
	"IA",
	"KS",
	"KY",
	"LA",
	"ME",
	"MD",
	"MA",
	"MI",
	"MN",
	"MS",
	"MO",
	"MT",
	"NE",
	"NV",
	"NH",
	"NJ",
	"NM",
	"NY",
	"NC",
	"ND",
	"OH",
	"OK",
	"OR",
	"PA",
	"RI",
	"SC",
	"SD",
	"TN",
	"TX",
	"UT",
	"VT",
	"VA",
	"WA",
	"WV",
	"WI",
	"WY",
]

export function valid_coa(coa) {
	// Permitted charaters 26 alpha, numeric
	// Permitted length 8
	let len = coa.length
	const pattern = /[0-9a-zA-Z]/
	if (len === 0) {
		return true
	}
	if (pattern.test(coa) && len <= 8) {
		return true
	} else {
		return false
	}
}
export function IsNumber(num) {
	const pattern = /[0-9]{1,}/
	console.log(num)
	if (pattern.test(num)) {
		console.log("IsNumber true")
		return true
	} else {
		console.log("IsNumber false")
		return false
	}
}
export function title_Case(str) {
	return str.replace(/\b\w/g, (c) => c.toUpperCase())
}

export function cap_Name(name) {
	// Strip leading and trailing blanks
	// Capitalize the first letter of a name
	// Lowercase the remainder of the name
	// Return the new string
	let txt = ""
	txt = name.substr(0, 1).toUpperCase()
	txt = txt.concat(name.substr(1))
	return txt
}
export function valid_state_code(txt) {
	const uppercaseInput = txt.toUpperCase()
	if (validStateCodes.includes(uppercaseInput) && txt.length === 2) {
		return true
	}
	return false
}

export function valid_PhoneNumber(num, isDeleting = false) {
	// PURPOSE:
	//      Validate the input string.
	//      Valid input: 0-9. All other characters are ignored.
	//      Valid input has a white background color, invalid is pick
	//      Maximum characters for North American is 12.
	//      North American numbers use dashes on the fourth and eigth characters
	//      International number formats are not handled.

	let phoneNo = num
	let errMsg = ""
	let isValid = false
	const pattern = /^[0-9]{3}[-][0-9]{3}[-][0-9]{4}$/
	let len = num.length

	if (pattern.test(num) || len === 0) {
		isValid = true
		return [isValid, errMsg, phoneNo]
	} else {
		if (num.length === 4 && num.at(3) === "-") {
			num = num.slice(0, 3)
			phoneNo = num
			return [isValid, errMsg, phoneNo]
		}
		if (num.length === 8 && num.at(7) === "-") {
			num = num.slice(0, 7)
			phoneNo = num
			return [isValid, errMsg, phoneNo]
		}
		if ((num.length === 3 || num.length === 7) && !isDeleting) {
			num = num + "-"
			phoneNo = num
			return [isValid, errMsg, phoneNo]
		}
		if (num.length > 12) {
			num = num.slice(0, 12)
			phoneNo = num
			isValid = pattern.test(num)
			return [isValid, errMsg, phoneNo]
		}
		return [isValid, errMsg, phoneNo]
	}
}
export function valid_FloodZone(fz) {
	const regex = new RegExp("[^0-9][A][AE][AH][AO][AR][A99][V][VE][X][D][B/C]")
	let len = fz.length
	if (len < 4 && !regex.test(fz)) {
		return true
	} else {
		return false
	}
}
export function valid_Num_Addr(txt) {
	// Permitted charaters numeric
	// Length < 6

	const regex = new RegExp("[^0-9]")
	let len = txt.length
	if (len < 6 && !regex.test(txt)) {
		return true
	} else {
		return false
	}
}
export function valid_PropCode(name) {
	// Permitted charaters 26 alpha, numeric
	// Length < 100
	// No spaces means no second names

	const regex = new RegExp("[^a-zA-Z0-9]")
	let len = name.length
	if (len < 100 && !regex.test(name)) {
		return true
	} else {
		return false
	}
}

export function valid_Address(name) {
	// Permitted charaters 26 alpha, hyphen, numeric
	// Length < 100
	// No spaces means no second names

	const regex = new RegExp("[^a-zA-Z0-9 -]")
	let len = name.length
	if (len < 100 && !regex.test(name)) {
		return true
	} else {
		return false
	}
}
export function valid_ItemValue(txt) {
	// Permitted charaters 26 upper alpha, numeric,hyphen,dot, @
	// Length < 51

	const regex = new RegExp("[^A-Z0-9-.@]")
	let len = txt.length
	if (len === 0 || (len < 51 && !regex.test(txt))) {
		return true
	} else {
		return false
	}
}
export function valid_Name(name) {
	// Permitted charaters 26 alpha, hyphen, apostrophe, space
	// Length < 51

	const regex = new RegExp("[^a-zA-Z\\-' ]")
	let len = name.length
	if (len === 0 || (len < 51 && !regex.test(name))) {
		return true
	} else {
		return false
	}
}

export function strip_Name(name) {
	// Remove any character not permitted in a person's name
	return name.replace(/[^a-zA-Z\-' ]/g, "")
}
export function valid_Zip5(zip) {
	// Permitted charaters 5 numeric
	const regex = new RegExp("[0-9]{5}")
	if (regex.test(zip)) {
		return true
	} else {
		return false
	}
}
export function valid_Zip(zip) {
	// Permitted charaters 9 numeric, dash
	const regex_9 = new RegExp("[0-9]{5}[-][0-9]{4}")
	const regex_5 = new RegExp("[0-9]{5}")
	if (zip.length === 5) {
		if (regex_5.test(zip)) {
			return true
		} else {
			return false
		}
	} else if (zip.length === 10) {
		if (regex_9.test(zip)) {
			return true
		} else {
			return false
		}
	}
}
export function valid_Email(email) {
	// Permitted alpha, numeric, @, dot, underscore, hyphen
	// Composition: prefix @ domain name . top level domain
	// Prefix: max 64 char case insensitive
	//          alpha | numeric | special
	//          Special: !#%&'*+-/=?^_`{|}~         not used
	//          Can't start/end with special char   not used
	// Domain Name: max 253 char
	// Label (domain name separated by a dot): max 63 char can't start/end with hyphen
	// TLD:  max 63 char after last dot

	// We use a conventional regex which is not foolproof
	// No pattern length checking is enforced

	// We may want to sign up for an API email validation service.
	// Let's see what our experience is first. Check hard bounces & complaints.

	// Improved regexp
	const regex = new RegExp(
		/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
	)
	// Original regexp
	// const regex = new RegExp("^[a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+.[a-zA-Z]$")
	//                         ---prefix---   @ ---domain---  . ---tld---
	let len = email.length
	if ((len < 50 && regex.test(email)) || len === 0) {
		return true
	} else {
		return false
	}
}
export function cents_to_dollars(cents, units) {
	let len = cents.length
	if (len === 1) {
		return "$0.0" + cents + " " + units
	}
	if (len === 2) {
		return "$0." + cents + " " + units
	}
	if (len === 3) {
		return "$" + cents.slice(0, 1) + "." + cents.slice(1) + " " + units
	}
	if (len === 4) {
		return "$" + cents.slice(0, 2) + "." + cents.slice(2) + " " + units
	}
	if (len === 5) {
		return "$" + cents.slice(0, 3) + "." + cents.slice(3) + " " + units
	}
	if (len === 6) {
		return (
			"$" +
			cents.slice(0, 1) +
			"," +
			cents.slice(1, 4) +
			"." +
			cents.slice(4) +
			" " +
			units
		)
	}
}
export function valid_MeterSN(txt) {
	// Need to determine the format of the meter serial number. For now, we will just check that it is not empty.
	if (txt !== "") {
		return true
	} else {
		return false
	}
}
export function valid_monthly(txt) {
	// Monthly Water, Monthly Sewer, or One Time Only
	if (txt !== "") {
		return true
	} else {
		return false
	}
}

export function valid_service_class(txt) {
	// Monthly Water, Monthly Sewer, or One Time Only
	if (txt !== "") {
		return true
	} else {
		return false
	}
}

export function valid_service_description(desc) {
	// Monthly Water, Monthly Sewer, or One Time Only
	if (desc !== "") {
		return true
	} else {
		return false
	}
}
export function valid_units(txt) {
	// KiloGal, Each, Percent
	if (txt !== "") {
		return true
	} else {
		return false
	}
}

export function valid_amount(cents) {
	const pattern = /^[0-9-]*$/
	let len = cents.length
	if ((pattern.test(cents) || len === 0) && len < 7) {
		return true
	} else {
		return false
	}
}

export function valid_lower_limit(wlimit) {
	let len = wlimit.length
	if (wlimit >= 0 && len > 0) {
		return true
	} else {
		return false
	}
}
export function valid_upper_limit(ulimit, llimit) {
	let len = ulimit.length
	if ((ulimit > 0 && ulimit > llimit) || len === 0) {
		return true
	} else {
		return false
	}
}
export function valid_date(date) {
	const pattern = /^[0-9]{4}[-][0-9]{2}[-][0-9]{2}$/
	let len = date.length
	if (pattern.test(date) || len === 0) {
		return true
	} else {
		return false
	}
}

export function valid_end_date(edate, sdate) {
	const pattern = /^[0-9]{4}[-][0-9]{2}[-][0-9]{2}$/
	let len = edate.length
	if (len === 0 || (pattern.test(edate) && edate > sdate)) {
		return true
	} else {
		return false
	}
}

export function int_to_currency(cents) {
	cents = cents.toString()
	let len = cents.length
	if (len === 1) {
		return "$0.0" + cents
	}
	if (len === 2) {
		return "$0." + cents
	}
	if (len === 3) {
		return "$" + cents.slice(0, 1) + "." + cents.slice(1)
	}
	if (len === 4) {
		return "$" + cents.slice(0, 2) + "." + cents.slice(2)
	}
	if (len === 5) {
		return "$" + cents.slice(0, 3) + "." + cents.slice(3)
	}
	if (len === 6) {
		return (
			"$" + cents.slice(0, 1) + "," + cents.slice(1, 4) + "." + cents.slice(4)
		)
	}
	if (len === 7) {
		return (
			"$" + cents.slice(0, 2) + "," + cents.slice(2, 4) + "," + cents.slice(5)
		)
	}
}
